import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-section-header',
  template: `
    <div class="section-header" [ngClass]="props.customClass" id={{props.id}}>
      <h3 class="section-title">{{ props.label }}</h3>
    </div>
  `,
  styleUrls: ['./section-header.type.scss'],
})
export class SectionHeaderType extends FieldType<FieldTypeConfig> { }
